import type { IconSvgObject } from './types';

const PlusMinus01Icon: IconSvgObject = [
  ["path", { d: "M12 3V17M19 10H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 21H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PlusMinus01Icon;
